import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private readonly debugEnabled = !environment.production;

  debug(...args: unknown[]): void {
    if (this.debugEnabled) {
      // eslint-disable-next-line no-console
      console.debug(...args);
    }
  }

  info(...args: unknown[]): void {
    if (this.debugEnabled) {
      // eslint-disable-next-line no-console
      console.info(...args);
    }
  }

  warn(...args: unknown[]): void {
    if (this.debugEnabled) {
      // eslint-disable-next-line no-console
      console.warn(...args);
    }
  }

  error(...args: unknown[]): void {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
}
